import { createContext } from "react"

export type SupportRequest = {
    projectId: number
    supportRequestId: number
    workstreamId: number
    workstream: string
    workPackageId: number
    workPackage: string
    requestType: string
    rating: string
    description: string
    raisedBy: string
    owner: string
    userId: string
    date: Date
    dueDate: Date
    status: "Cancelled" | "Complete" | "Open" | "Closed"
    notes: string
    displayOnDashboard: boolean
    displayOnStatusReport: boolean
    seen: boolean
    acknowledged: boolean
}

interface SupportRequestContextProps {
    dialogOpen: boolean;
    setDialogOpen: (open: boolean) => void;
    supportTableDemoContent: SupportRequest[];
    setSupportTableDemoContent: (content: SupportRequest[]) => void;
    showPopup: (supportRequest: SupportRequest) => void;
    demoMode: boolean;
    setDemoMode: (mode: boolean) => void;
    rowSelection: {};
    setRowSelection: React.Dispatch<React.SetStateAction<{}>>;
    addSupportRequest: () => void;
}

export const SupportRequestContext = createContext<SupportRequestContextProps>({
    dialogOpen: false,
    setDialogOpen: () => {},
    supportTableDemoContent: [],
    setSupportTableDemoContent: () => {},
    showPopup: () => {},
    demoMode: false,
    setDemoMode: () => {},
    rowSelection: {},
    setRowSelection: () => {},
    addSupportRequest: () => {},
});
